import {useLiveChat} from '../utils/livechat.js'

(function () {
    'use strict';

    angular.module('headerModule', ['journey.veil', 'JB.translate.srv', 'auth.srv'])
        .controller('headerCtrl', ['$scope', '$location', '$rootScope', '$stateParams', 'Session', 'canvasService', 'APRO_BME_URL', 'helpers', headerController]);

    function headerController($scope, $location, $rootScope, $stateParams, Session, canvasService, APRO_BME_URL, helpers) {
        //Checks if path contains canvas word in the url
        var isCanvasPath = function () {
            return $location.path().indexOf('canvas') > -1;
        };

        useLiveChat(helpers.readCookie('L') || 'english');

        $('body').on('click', function() {
            $scope.showGlobalHelpMenu = false;
            $scope.$apply();
        })

        $scope.parseName = (name) => {
            var parseName = name;

            if (name && name.length > 40) {
                parseName = name.slice(0, 40) + '...';
            }

            return parseName;
        };

        $scope.bmeUrl = APRO_BME_URL;

        //Flag to show Journey name Box.
        $scope.showBox = false;

        //Flag to show extra veil on creating new canvas
        $scope.extraCanvasVeil = false;

        //show or hide pencil
        $scope.showPencil = false;

        // show global help menu
        $scope.showGlobalHelpMenu = false;

        // show / hide tooltip for global help button
        $scope.tooltipState = false;

        //Flag to display Journey name/title on Canvas URL
        $scope.journeyTitle = isCanvasPath();
        $scope.$emit('displayVeil', isCanvasPath());

        $scope.showHeader = isCanvasPath();

        //Checking url to display the header module on the canvas section
        $rootScope.$on('pageLocationChanged', function(evt, next) {
            $scope.showHeader = (next.name.indexOf('canvas') > -1 && isCanvasPath());
        });

        // $watch the method to see if it already got resolved
        $rootScope.$watch('translate', function (key) {
            //Flag to display Journey name on Canvas URL
            if (typeof key === 'function') {
                $scope.journeyTplName = $rootScope.translate('canvas.header.title');
            }
        });

        $scope.$watch('journeyTplName', function(val){
            $rootScope.currentJBTitle = val;
        });

        //Function to display Journey name on Header.
        $scope.showBoxName = function () {
            $scope.showBox = true;
        };

        //Function to hide Journey box template
        $scope.saveJourneyTplName = function () {
            if ($scope.journeyTplName == "") {
                //Error msg from backend when failing
                $rootScope.$emit('errorMsg', $scope.translate('canvas.header.pleaseAddJourneyName'));
                $scope.displayError = true;
            } else {
                $scope.$emit('createEmail');
            }
        };

        $scope.toggleGlobalHelpMenu = function() {
            $scope.tooltipState = false;
            $scope.showGlobalHelpMenu = !$scope.showGlobalHelpMenu;
        }

        $scope.toggleTooltip = function(show) {
          $scope.tooltipState = show;
        };

        $scope.liveChat = function() {
            if (window.LC_API) {
                window.LC_API.open_chat_window();
            }
        };

        //Checking url to display Journey name Element.
        $scope.$on('$locationChangeStart', function () {
            $scope.journeyTitle = isCanvasPath();
            $scope.showBox = !isCanvasPath();
            $scope.$emit('displayVeil', isCanvasPath());
            $scope.extraCanvasVeil = false;
        });

        //When canvas already exists we change the title
        $rootScope.$on('journey-title', function (events, args) {
            $scope.journeyTplName = args.name;
        });

        //Display the box when new canvas
        $scope.$on('show-box', function () {
            $scope.journeyTplName = '';
            $scope.showBoxName();
            //Extra veils to hide header and footer
            $scope.extraCanvasVeil = true;
        });

        $scope.contMenu = 0;
        $scope.stopMenuBroadcast = function() {
            $scope.contMenu = 0;
        };

        $scope.$on('hideHeaderHomeMenu', function() {
            if($scope.showBox) {
                if ($scope.contMenu === 0) {
                    $scope.contMenu = 1;
                }else {
                    if($scope.journeyTplName) {
                        $scope.$emit('createEmail', true);
                        $scope.showBox = false;
                        $scope.contMenu = 0;
                    }
                }
            }else {
                $scope.contMenu = 0;
            }
        });

        //Log out from the app
        $scope.exit = function() {
            Session.destroy();
            window.location = 'http://ui.benchmarkemail.com/Login'
        };

        $scope.displayFaq = () => {
            //Track Event Intecrom - Help Overlay
            Intercom('trackEvent', 'AP - Help Overlay');
            $rootScope.$emit('displayFAQ');
        };

        $scope.redirectHome = () => {
            window.location = APRO_BME_URL;
        };

        $scope.displayTrackingReports = () => {
            $rootScope.$emit('trackingReports');
        };

        $rootScope.$on('displayTrackingCanvas', () => {
            $scope.displayTracking();
        });

        $scope.displayTracking = (tplName = 'tracking-code') => {
            if($rootScope.getTrackerToken) {
                $rootScope.$emit('displayTracking', tplName, $rootScope.getTrackerToken)
            }
            else {
                Intercom('trackEvent', 'AP Tracking Code Overlay');

                canvasService
                    .getTrackerToken()
                    .success(function (token) {
                        $rootScope.getTrackerToken = token;
                        $rootScope.$emit('displayTracking', tplName, token)
                    })
                    .error(function() {
                        $rootScope.$emit('errorMsg', $scope.translate('canvas.error.607'));
                    });
            }
        };

        $rootScope.$on('displayTrackerModal', () => {
            $scope.displayTracking();
        });

        $rootScope.$watch('currentJourneyStatus', function(status) {
            if(status == 1) {
                $scope.showPencil = true;
            }
        });

        $scope.defineStatus = function(capitalize) {
            let res = $scope.translate('dashboard.inactive');
            if($rootScope.currentJourneyStatus === 3 || $rootScope.currentJourneyStatus === 8) {
                res = $scope.translate('dashboard.active');
            } else if($rootScope.currentJourneyStatus === 4) {
                res = $scope.translate('dashboard.deactivated');
            }
            if(capitalize) {
                res = res.firstUpper();
            }

            return res;
        };

        $scope.defineStatusClass = function() {
            let res = 'inactive';
            if($rootScope.currentJourneyStatus === 3 || $rootScope.currentJourneyStatus === 8) {
                res = 'active';
            } else if($rootScope.currentJourneyStatus === 4) {
                res = 'deactivated';
            }

            return res;
        };
    }

})();



// WEBPACK FOOTER //
// ./app/controllers/headerController.js